import React, { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid, LineChart, Line } from "recharts";

export default function OwnerFinance() {
  const [f, setF] = useState(null);
  useEffect(() => { http.get("/ops/financial?months=6").then(({ data }) => setF(data)); }, []);
  if (!f) return <div className="text-muted-foreground">Loading…</div>;

  const trend = f.trend.map((t) => ({ ...t, month: t.month.slice(2) }));

  return (
    <div className="space-y-6" data-testid="owner-finance">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground">Financial</div>
        <h1 className="font-display text-3xl font-bold text-primary">Financial Reporting</h1>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <StatCard label="Outstanding invoices" value={f.outstanding_count} />
        <StatCard label="Outstanding amount" value={`$${f.outstanding_amount.toLocaleString()}`} />
        <StatCard label="Communities generating revenue" value={f.revenue_by_community.length} />
      </div>

      <Card className="border-border/60"><CardContent className="p-6">
        <div className="font-display font-semibold text-primary mb-4">Monthly revenue trend</div>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={trend}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
              <XAxis dataKey="month" stroke="#64748b" fontSize={12} />
              <YAxis stroke="#64748b" fontSize={12} />
              <Tooltip formatter={(v) => `$${v}`} />
              <Bar dataKey="paid" fill="hsl(146 50% 45%)" name="Paid" radius={[6, 6, 0, 0]} />
              <Bar dataKey="outstanding" fill="hsl(213 73% 25%)" name="Outstanding" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent></Card>

      <Card className="border-border/60"><CardContent className="p-0">
        <div className="p-4 border-b border-border/60 font-display font-semibold text-primary">Revenue by community</div>
        {f.revenue_by_community.length === 0 ? (
          <div className="p-10 text-center text-muted-foreground">No revenue yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-muted/40 text-xs uppercase tracking-wider text-muted-foreground">
              <tr><th className="text-left p-3">Community</th><th className="text-right p-3">Lifetime revenue</th></tr>
            </thead>
            <tbody>
              {f.revenue_by_community.map((r) => (
                <tr key={r.community_id} className="border-t border-border/60">
                  <td className="p-3">{r.community_name}</td>
                  <td className="p-3 text-right font-semibold">${r.revenue.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </CardContent></Card>
    </div>
  );
}

function StatCard({ label, value }) {
  return <Card className="border-border/60"><CardContent className="p-5">
    <div className="text-xs uppercase tracking-wider text-muted-foreground">{label}</div>
    <div className="font-display text-3xl font-bold text-primary mt-1">{value}</div>
  </CardContent></Card>;
}
